import { IDirective, IDirectiveFactory, IScope } from "angular";
import { ProgressColoring } from "@gtmhub/configuration";

interface IAttainmentScope extends IScope {
  value: number;
  color: string;
}

export class Attainment implements IDirective {
  public scope = {
    value: "@",
  };
  public restrict = "E";
  public transclude = true;
  public template =
    "<div style='border-radius: 3px; overflow: hidden; width: 100%; background: #eee; heigth: 5px;'>" +
    "<div style='height: 5px; background: {{color}};width: {{value}}%'></div></div>";

  constructor(private progressColoring: ProgressColoring) {}

  public link(scope: IAttainmentScope): void {
    if (!scope.value) {
      scope.value = 0;
    }

    // The value is passed as a percentage and not as a decimal value
    // Therefore we need to convert it to a decimal value
    scope.color = this.progressColoring.getColorOrGeneric(scope.value / 100);
  }

  public static factory(): IDirectiveFactory {
    const directive = (progressColoring: ProgressColoring) => new Attainment(progressColoring);
    directive.$inject = ["ProgressColoring"];
    return directive;
  }
}
